/** Connection / zone colors — clear on dark canvas, not neon. */
export const DIAGRAM_COLOR_PALETTE = [
  { id: 'default', labelUk: 'За замовчуванням', hex: '' },
  { id: 'sky', labelUk: 'Блакитний', hex: '#38bdf8' },
  { id: 'blue', labelUk: 'Синій', hex: '#3b82f6' },
  { id: 'teal', labelUk: 'Бірюзовий', hex: '#2dd4bf' },
  { id: 'green', labelUk: 'Зелений', hex: '#34d399' },
  { id: 'lime', labelUk: 'Салатовий', hex: '#a3e635' },
  { id: 'amber', labelUk: 'Бурштиновий', hex: '#fbbf24' },
  { id: 'orange', labelUk: 'Помаранчевий', hex: '#fb923c' },
  { id: 'rose', labelUk: 'Рожевий', hex: '#fb7185' },
  { id: 'violet', labelUk: 'Фіолетовий', hex: '#a78bfa' },
  { id: 'slate', labelUk: 'Сірий', hex: '#94a3b8' },
] as const;

export type DiagramPaletteId = (typeof DIAGRAM_COLOR_PALETTE)[number]['id'];

export const DEFAULT_ZONE_COLOR = '#60a5fa';
export const DEFAULT_EDGE_COLOR = '#38bdf8';

/** Convert #RGB / #RRGGBB to rgba() for translucent zone fills. */
export function hexToRgba(hex: string, alpha: number): string {
  const raw = hex.trim().replace(/^#/, '');
  if (!/^[0-9a-fA-F]{3}$|^[0-9a-fA-F]{6}$/.test(raw)) {
    return `rgba(56, 189, 248, ${alpha})`;
  }
  const full =
    raw.length === 3
      ? raw
          .split('')
          .map((c) => c + c)
          .join('')
      : raw;
  const r = Number.parseInt(full.slice(0, 2), 16);
  const g = Number.parseInt(full.slice(2, 4), 16);
  const b = Number.parseInt(full.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export function normalizeDiagramColor(value: string | undefined | null): string | undefined {
  const v = value?.trim();
  if (!v) return undefined;
  if (!/^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(v)) return undefined;
  return v.length === 4
    ? `#${v[1]}${v[1]}${v[2]}${v[2]}${v[3]}${v[3]}`.toLowerCase()
    : v.toLowerCase();
}
